import { render, staticRenderFns } from "./NewsCategoryOrTag.vue?vue&type=template&id=1e224809&scoped=true&"
import script from "./NewsCategoryOrTag.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryOrTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e224809",
  null
  
)

export default component.exports